import axiosInstance, { axiosMultipartFormDataInstance } from './axiosInstance';
import { API_PATH, API_VERSION } from './constants';

const companySerive = {
    getAllCompanies: () => axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}`),
    getCompanyByHash: (companyHash) => axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyHash}`),
    getUserCompany: () => axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${API_PATH.MY_COMPANY}`),
    getCustomerSettings: (companyId) => axiosInstance.get(`/${API_VERSION}/${API_PATH.CUSTOMERS}/${companyId}`),
    getEditCustomerSettings: (customerId) => axiosInstance.get(`/${API_VERSION}/${API_PATH.CUSTOMERS}/${customerId}/${API_PATH.EDIT}`),
    getChannelAndVendor: () => axiosInstance.get(`/${API_VERSION}/${API_PATH.CHANNEL}`),
    editCustomerDetails: (data) => axiosMultipartFormDataInstance.post(`/${API_VERSION}/${API_PATH.CUSTOMERS}`,data),
    deleteCustomerSettings: (customerId) => axiosInstance.delete(`/${API_VERSION}/${API_PATH.CUSTOMERS}/${customerId}`),
    getCompanyConfigurationByTag: (companyId) => axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CONFIG}/${API_PATH.TAG}/useUnified`),
    postCompanyConfiguration: (companyId, data) => axiosInstance.post(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CONFIG}`, data),
    postCompanyConfigurationAuto: (companyId, data) => axiosInstance.post(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CONFIG}/auto`, data)
};

export default companySerive;
